export const NextReviewDateFields = {
	NextCreditReviewDate: {
		name: "nextCreditReviewDate",
		displayName: "Next Credit Review Date",
		beName: "next_credit_review_date",
	},
	NextChargebackReviewDate: {
		name: "nextChargebackReviewDate",
		displayName: "Next Chargeback Review Date",
		beName: "next_chargeback_review_date",
	},
};

export const DesiredLimitsFields = {
	MonthlyVMCD: {
		name: "monthlyVMCD",
		displayName: "Average Monthly Volume, $",
		beName: "visa_mc_discover_amv",
	},
	AvgTicketVMCD: {
		name: "avgTicketVMCD",
		displayName: "Average Ticket, $",
		beName: "visa_mc_discover_avt",
	},
	HighTicketVMCD: {
		name: "highTicketVMCD",
		displayName: "High Ticket, $",
		beName: "visa_mc_discover_ht",
	},
	MonthlyAMEX: {
		name: "monthlyAMEX",
		displayName: "Average Monthly Volume, $",
		beName: "amex_amv",
	},
	AvgTicketAMEX: {
		name: "avgTicketAMEX",
		displayName: "Average Ticket, $",
		beName: "amex_avt",
	},
	HighTicketAMEX: {
		name: "highTicketAMEX",
		displayName: "High Ticket, $",
		beName: "amex_ht",
	},
	FundingTypes: {
		name: "fundingTypes",
		displayName: "Funding Types",
		beName: "funding_type",
	},
	DailyDiscount: {
		name: "dailyDiscount",
		displayName: "Daily Discount",
		beName: "is_daily_discount",
	},
};

export const CreditReviewFields = {
	ChargebackVolume: {
		name: "chargebackVolume",
		displayName: "Chargeback Volume, $",
		beName: "chargeback_volume",
	},
	RiskExposure: {
		name: "riskExposure",
		displayName: "Risk Exposure",
		beName: "risk_exposure",
	},
	Reserve: {
		name: "reserve",
		displayName: "Reserve, %",
		beName: "reserve",
	},
	ReserveAmount: {
		name: "reserveAmount",
		displayName: "Reserve Amount, $",
		beName: "reserve_amount",
	},
};
